app.service('deliveryTracking', function () {
	var $ordersCollection;

	function loadSuccess(html, orderNumber) {
		$ordersCollection.filter('[data-tracking-id="'+orderNumber+'"]').removeClass('loading').html(html);
	}

	function showDeliveryTrackingHistory() {
		const $historySteps = $(this).prev('.delivery-tracking-history-steps');
		$historySteps.toggleClass('delivery-tracking-history-full');
	}

	function getCourierStatusesDelivery(orderNumber, guestLogged) {
		$.ajax({
			url: guestLogged ? '/guest-tracking-status-details.ltr' : '/customer-tracking-status-details.ltr',
			data: {
				orderNumber: orderNumber
			},
			success: function(html) {
				loadSuccess(html, orderNumber);
			},
			error:function() {
				loadSuccess('<div class="error-message">Błąd pobierania danych.<div>', orderNumber);
			}
		});
	}

	function setElements() {
		$ordersCollection = $('.delivery-tracking');
	}

	function setEvents() {
		$('body').on('click','.js-delivery-tracking-full-history', showDeliveryTrackingHistory);
		if ($ordersCollection.length) {
			$ordersCollection.each( function() {
				const orderNumber = $(this).data('tracking-id');
				const guest = $(this).data('guest');
				getCourierStatusesDelivery(orderNumber, guest);
			});
		}
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init
	};
});
